import { h } from 'preact';
import StockDetailsPage from '../stock-details-page';
import Filter from './filter';

export default function HistoricalDataPanel(props) {
	return  (
		<StockDetailsPage showCurrencyIndicator {...props}>
			<Filter {...props} />
		</StockDetailsPage>
	);
}
